// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AlertUtils } from '@shared/utils/Alert/AlertUtils';
import CreateAlertNotificationSelectorTemplate from '@front/templates/CreateAlertNotificationSelectorTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { AlertNotification } from '@shared/utils/Alert/AlertConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertNotificationSelector extends ContainerControl {
    constructor() {
        super();
        // for add from Code like PropertySetupScreen
        this.ValueChanged = new CustomEvent();
    }
    getType() {
        return 'CreateAlertNotificationSelector';
    }
    oninit() {
        super.oninit();
        this.observe('selectedValue', this.repopulate); //, { init: false });
        this.on('selectionValueChange', this.McbValueChanged);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    repopulate() {
        const value = this.get('selectedValue');
        const items = AlertUtils.GetAlertNotificationItems(value);
        void this.set({ items });
    }
    McbValueChanged() {
        var _a;
        const items = this.get('items');
        let res = 0;
        for (let i = 0; i < items.length; i++) {
            if (items[i].checked) {
                res += items[i].value;
            }
        }
        void this.set({ selectedValue: res || AlertNotification.SHOW_POP_UP });
        if (!res) {
            this.repopulate();
        }
        (_a = this.ValueChanged) === null || _a === void 0 ? void 0 : _a.Raise(this, res || AlertNotification.SHOW_POP_UP);
    }
    localize() {
        void this.set({
            label: Resources.getResource('screen.Alerts.Label.Notify'),
            // infoBtnTooltip: Resources.getResource('screen.Alerts.Label.Notify.InfoTooltip')
            allItemsSelectedText: Resources.getResource('screen.Alerts.Notify.All'),
            noItemsSelectedText: 'No notifications', // Resources.getResource('panel.TerceraSymbolLookupDropDownForm.exchangeComboBox.No exchanges'),
            fewItemsSelectedPostfixText: Resources.getResource('screen.Alerts.Notify.Few')
        });
    }
}
ContainerControl.extendWith(CreateAlertNotificationSelector, {
    template: CreateAlertNotificationSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: null,
            selectedValue: AlertNotification.SHOW_POP_UP // 1+2+4+8=15
        };
    }
});
